import { Col, Container, Row } from "react-bootstrap";
import CreaPng from '../../assets/img/roadmap/crea-removebg-preview.png';
import GoldPng from '../../assets/img/roadmap/gold-removebg-preview.png';
import OrangePng from '../../assets/img/roadmap/orange-removebg-preview.png';
import StripedPng from '../../assets/img/roadmap/striped.png';

function Roadmap() {
    return <Container>
        <h2 className="text-center ml-5 mb-5">Roadmap</h2>
        <Row>
            <Col xs={{ span: 12 }} md={{ offset: 5, span: 2 }} className="vertical-bar">
                <div className="roadmap-vt"></div>
                <div className="roadmap-img">
                    <img src={CreaPng} />
                </div>
                <div className="roadmap-v"></div>
            </Col>
            <Col xs={12} md={5}>
                <div className="alt-event">
                    <p className="date">Phase 1</p>
                    <ul>
                        <li><p className="txt">Series A Funding for Solporate Cats (Whitelist and Public Mint)</p></li>
                        <li><p className="txt">Marketplace and Verification for Holders</p></li>
                        <li><p className="txt">Establish Solporate DAO</p></li>
                    </ul>
                </div>
            </Col>
        </Row>

        <Row>
            <Col xs={12} md={5}>
                <div className="alt-event">
                    <p className="date">Phase 2</p>
                    <ul>
                        <li><p className="txt">Solporate DAO Council Established</p></li>
                        <li><p className="txt">Start Business Trips</p></li>
                        <li><p className="txt">Sub-DAOs Established</p></li>
                    </ul>
                </div>
            </Col>
            <Col xs={{span: 12, order: 'first'}} md={{span: 2, order: 'last'}} className="vertical-bar">
                <div className="roadmap-vt"></div>
                <div className="roadmap-img right">
                    <img src={GoldPng} />
                </div>
                <div className="roadmap-v"></div>
            </Col>
        </Row>
        <Row>
            <Col xs={{ span: 12 }} md={{ offset: 5, span: 2 }} className="vertical-bar">
                <div className="roadmap-vt"></div>
                <div className="roadmap-img">
                    <img src={OrangePng} />
                </div>
                <div className="roadmap-v"></div>
            </Col>
            <Col xs={12} md={5}>
                <div className="alt-event">
                    <p className="date">Phase 3</p>
                    <ul>
                        <li><p className="txt">DAO War</p></li>
                        <li><p className="txt">Promotions</p></li>
                        <li><p className="txt">Hiring Season</p></li>
                        <li><p className="txt">Sub-Company Launch</p></li>
                        <li><p className="txt">Solporate Shop — Buy things with $PURR</p></li>
                    </ul>
                </div>
            </Col>

        </Row>

        <Row>
            <Col xs={12} md={5}>
                <div className="alt-event">
                    <p className="date">Solporate World</p>
                    <ul>
                        <li><p className="txt">Solporate VC</p></li>
                        <li><p className="txt">Solporate CrowdFunding</p></li>
                        <li><p className="txt">Solporate Real Estate</p></li>

                    </ul>
                </div>
            </Col>
            <Col xs={{span: 12, order: 'first'}}  md={{span: 2, order: 'last'}} className="vertical-bar">
                <div className="roadmap-vt"></div>
                <div className="roadmap-img right">
                    <img src={StripedPng} />
                </div>
                <div className="roadmap-v"></div>
            </Col>
        </Row>


    </Container>
}

export default Roadmap;